<div class="settings-tab-persona-container">
  <header class="settings-tab-persona-header">
    <h2 class="settings-tab-persona-header-title">
      Manage <strong>Persona</strong>
      <span *ngIf="!loadingQuota && userPersonaQuota" class="settings-tab-persona-header-title-quota">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="2.5" fill="url(#paint0_linear_1184_46092)" />
          <path
            d="M13.1345 14.4741H11.1692L10.3879 12.4417H6.81128L6.07275 14.4741H4.15625L7.64136 5.52637H9.55176L13.1345 14.4741ZM9.80811 10.9341L8.5752 7.61377L7.3667 10.9341H9.80811Z"
            fill="white"
          />
          <path d="M14.0439 14.4741V5.52637H15.8506V14.4741H14.0439Z" fill="white" />
          <defs>
            <linearGradient
              id="paint0_linear_1184_46092"
              x1="2.69496e-07"
              y1="10"
              x2="18.75"
              y2="20"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5F177F" />
              <stop offset="1" stop-color="#F15A2A" />
            </linearGradient>
          </defs>
        </svg>
        {{ userPersonaQuota.created }}/{{ userPersonaQuota.quota }} Personas
      </span>
    </h2>
    <p class="settings-tab-persona-header-subtitle">
      Use Personas to help FlyMSG know who you are when we are writing for you. You'll define who we are speaking as
      when we generate posts, comments, and more.
    </p>
    <div class="settings-tab-persona-row row-between">
      <div class="settings-tab-persona-row row-left" style="width: unset; gap: 10px">
        <div class="settings-tab-persona-input-container" style="width: 280px">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z"
              stroke="#2A1E36"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M13.7031 13.7031L17.5 17.5"
              stroke="#2A1E36"
              stroke-width="1.42857"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <input
            id="settings-persona-search"
            type="text"
            placeholder="Search Persona"
            data-atx="false"
            [(ngModel)]="search"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="searchUserPersona()"
          />
        </div>

        <div class="settings-tab-persona-input-container" vngTourAnchor="step13-initial">
          <!-- R5: mat-select -> vng-select, data-driven (orderByOptions). vng-select
               renders its own trigger chevron, so the manual chevron svg is gone. -->
          <vng-select
            placeholder="Order by"
            [(ngModel)]="order"
            [ngModelOptions]="{ standalone: true }"
            [options]="orderByOptions"
            (selectionChange)="orderUserPersona()"
          ></vng-select>
        </div>
      </div>
      <button
        vng-button
        variant="primary"
        size="lg"
        type="button"
        class="settings-tab-persona-add-persona"
        vngTourAnchor="step13"
        (click)="goToNewPersona()"
        [disabled]="loadingQuota"
      >
        <vng-icon name="add" [outline]="false" color="inherit"></vng-icon>
        Add Persona
      </button>
    </div>
  </header>

  <div
    *ngIf="dataSource.filteredData.length < 1 && !loadingGetUsers"
    class="text-center fms-settings-persona-no-results"
  >
    <img src="../../../assets/images/Error.png" alt="No results found" />
    <div class="settings-persona-no-results">
      <h4>No Persona added</h4>
      <p>Start adding Persona by clicking the "Add Persona" button.</p>
    </div>
  </div>

  <div class="settings-persona-table-container" *ngIf="dataSource.filteredData.length > 0 || loadingGetUsers">
    <ngx-ui-loader [loaderId]="loaderId"></ngx-ui-loader>
    <!-- R8: mat-table + matSort + mat-paginator -> plain <table class="vng-table">
         + VngTableDataSource + vng-pagination. This table has no clickable
         sort headers (matSort was only ever driven programmatically by the
         "Order by" select above, via orderUserPersona()) so no per-column
         sort UI is needed here — pagedRows is a slice of
         dataSource.filteredData (post filter+sort, pre-page). -->
    <div class="vng-table-responsive">
      <table class="vng-table settings-persona-table">
        <thead>
          <tr>
            <th>Persona Name</th>
            <th>Persona Type</th>
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of pagedRows">
            <td [ngClass]="{ 'disabled-persona': element.disabled }">
              <strong>{{ element.name }}</strong>
              <span
                *ngIf="element.ai_emulation_stale"
                class="tw-inline-flex tw-items-center tw-gap-1 tw-text-xs tw-text-amber-700 tw-bg-amber-50 tw-rounded tw-px-1.5 tw-py-0.5 tw-ml-2"
                ngbPopover="The persona details changed after the AI emulation was generated. Open it and click Regenerate."
                popoverClass="settings-list-tab-new-persona-popover"
                data-fms-heap="persona-stale-badge"
              >
                <vng-icon name="warning" [outline]="false" [size]="14" color="warning"></vng-icon>
                Needs regeneration
              </span>
            </td>
            <td [ngClass]="{ 'disabled-persona': element.disabled }">
              {{ element.type === "person" ? "Person" : "Company" }}
            </td>
            <td class="col-actions" [ngClass]="{ 'disabled-persona': element.disabled }">
              <div class="account-center-users-actions-container">
                <button
                  class="cursor-point admin-table-action-btn"
                  ngbPopover="Edit Persona"
                  popoverClass="settings-list-tab-new-persona-popover"
                  (click)="goToUserPersona($event, element)"
                >
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.75 23.2498L13 22.2498L22.2929 12.957C22.6834 12.5664 22.6834 11.9333 22.2929 11.5427L20.4571 9.70696C20.0666 9.31643 19.4334 9.31643 19.0429 9.70696L9.75 18.9998L8.75 23.2498Z"
                      stroke="#141414"
                      stroke-width="1.125"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23.25 23.25H17.75"
                      stroke="#141414"
                      stroke-width="1.125"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>

                <button
                  class="cursor-point admin-table-action-btn"
                  ngbPopover="Duplicate Persona"
                  popoverClass="settings-list-tab-new-persona-popover"
                  (click)="duplicatePersona($event, element)"
                >
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.3783 19H4.53618C3.72566 19 3.0625 18.3045 3.0625 17.4545V6.63636H4.53618V17.4545H13.3783V19ZM15.5888 15.9091H7.48355C6.67303 15.9091 6.00987 15.2136 6.00987 14.3636V3.54545C6.00987 2.69545 6.67303 2 7.48355 2H15.5888C16.3993 2 17.0625 2.69545 17.0625 3.54545V14.3636C17.0625 15.2136 16.3993 15.9091 15.5888 15.9091ZM15.5888 3.54545H7.48355V14.3636H15.5888V3.54545Z"
                      fill="#5F177F"
                    />
                  </svg>
                </button>

                <ng-template #popContent style="border-radius: 8px">
                  <p><strong>Default Persona</strong></p>
                  <span> This persona will be used to generate content by default. </span>
                </ng-template>
                <button
                  class="cursor-point admin-table-action-btn"
                  [ngbPopover]="element.is_default ? popContent : 'Set as Default Persona'"
                  popoverClass="settings-list-tab-new-persona-popover"
                  (click)="setDefaultPersonaConfirm($event, element)"
                >
                  <svg
                    *ngIf="!element.is_default"
                    width="18"
                    height="21"
                    viewBox="0 0 18 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.875 4.73684C4.875 4.3299 5.21079 4 5.625 4H6.75H11.25H12.375C12.7892 4 13.125 4.3299 13.125 4.73684C13.125 5.14379 12.7892 5.47368 12.375 5.47368H12.0712L12.6849 12.1053H14.25C14.6642 12.1053 15 12.4351 15 12.8421C15 13.2491 14.6642 13.5789 14.25 13.5789H12H9.75V17.2632C9.75 17.6701 9.41423 18 9 18C8.58578 18 8.25 17.6701 8.25 17.2632V13.5789H6H3.75C3.33579 13.5789 3 13.2491 3 12.8421C3 12.4351 3.33579 12.1053 3.75 12.1053H5.31509L5.92873 5.47368H5.625C5.21079 5.47368 4.875 5.14379 4.875 4.73684ZM7.43491 5.47368L6.82127 12.1053H9H11.1787L10.5651 5.47368H7.43491Z"
                      fill="#5F177F"
                    />
                  </svg>
                  <svg
                    *ngIf="element.is_default"
                    width="18"
                    height="21"
                    viewBox="0 0 18 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.875 4.73684C4.875 4.3299 5.21079 4 5.625 4H6.75H11.25H12.375C12.7892 4 13.125 4.3299 13.125 4.73684C13.125 5.14379 12.7892 5.47368 12.375 5.47368H12.0712L12.6849 12.1053H14.25C14.6642 12.1053 15 12.4351 15 12.8421C15 13.2491 14.6642 13.5789 14.25 13.5789H12H9.75V17.2632C9.75 17.6701 9.41422 18 9 18C8.58578 18 8.25 17.6701 8.25 17.2632V13.5789H6H3.75C3.33579 13.5789 3 13.2491 3 12.8421C3 12.4351 3.33579 12.1053 3.75 12.1053H5.31509L5.92873 5.47368H5.625C5.21079 5.47368 4.875 5.14379 4.875 4.73684Z"
                      fill="#5F177F"
                    />
                  </svg>
                </button>

                <button
                  class="cursor-point admin-table-action-btn"
                  ngbPopover="Remove Persona"
                  popoverClass="settings-list-tab-new-persona-popover"
                  (click)="deletePersona($event, element)"
                >
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.7969 10.7188C15.236 10.7188 14.7812 11.1735 14.7812 11.7344V11.9375H17.2188V11.7344C17.2188 11.1735 16.764 10.7188 16.2031 10.7188H15.7969ZM18.4375 11.9375V11.7344C18.4375 10.5004 17.4371 9.5 16.2031 9.5H15.7969C14.5629 9.5 13.5625 10.5004 13.5625 11.7344V11.9375H11.7417C11.7373 11.9375 11.7329 11.9375 11.7284 11.9375H10.3125C9.97595 11.9375 9.70312 12.2103 9.70312 12.5469C9.70312 12.8834 9.97595 13.1562 10.3125 13.1562H11.1757L11.8107 20.4592C11.9111 21.6138 12.8777 22.5 14.0367 22.5H17.9633C19.1223 22.5 20.0889 21.6138 20.1893 20.4592L20.8243 13.1562H21.6875C22.024 13.1562 22.2969 12.8834 22.2969 12.5469C22.2969 12.2103 22.024 11.9375 21.6875 11.9375H20.2716C20.2671 11.9375 20.2627 11.9375 20.2583 11.9375H18.4375ZM19.601 13.1562H12.399L13.0249 20.3536C13.0705 20.8784 13.5099 21.2812 14.0367 21.2812H17.9633C18.4901 21.2812 18.9295 20.8784 18.9751 20.3536L19.601 13.1562Z"
                      fill="#F55555"
                    />
                  </svg>
                </button>
              </div>
            </td>
          </tr>

          <!-- Row shown when there is no matching search filter or items. -->
          <tr *ngIf="pagedRows.length === 0" style="background-color: #f7fafc">
            <td [attr.colspan]="displayedColumns.length" style="padding: 10px">
              <ngx-skeleton-loader
                *ngIf="loadingGetUsers"
                count="10"
                [theme]="{ 'border-radius': '2px', height: '40px' }"
              ></ngx-skeleton-loader>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- R8, 1-BASED PAGE NUMBERING: vng-pagination's currentPage/page are 1-based
       (page 1 = first page), unlike Material's mat-paginator pageIndex which is
       0-based. handlePageChange()/updatePagedRows() in the .ts do the 1-based
       array-offset math; the phantom appAccountCenterPaginator/[appCustomLength]
       bindings that were on the old mat-paginator (no such directive exists
       anywhere in the repo) are dropped here without behavior change. -->
  <vng-pagination
    *ngIf="dataSource.filteredData.length > 0 || loadingGetUsers"
    [totalItems]="dataSource.filteredData.length"
    [pageSize]="itemsPerPage"
    [currentPage]="currentPage"
    [pageSizeOptions]="[10, 25, 50, 100]"
    (pageChange)="handlePageChange($event)"
    style="align-self: start"
  ></vng-pagination>
</div>
